import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class PermissionsGroupCollectionsController 
{
    async create(data) 
    {
        const response = await api.permissionsGroupCollections().post(data);
        return apiCallbackTreatment(response);
    }

    async deleteById(id)
    {
        const response = await api.permissionsGroupCollections().remove(id);
        return apiCallbackTreatment(response);
    }

    async getByPermissionGroup(idPermissionGroup) 
    {
        const response = await api.permissionsGroupCollections().getByPermissionGroup(idPermissionGroup);
        return apiCallbackTreatment(response);
    }
}